import { render, staticRenderFns } from "./FaxTile.vue?vue&type=template&id=d146e34c&scoped=true&"
import script from "./FaxTile.vue?vue&type=script&lang=js&"
export * from "./FaxTile.vue?vue&type=script&lang=js&"
import style0 from "./FaxTile.vue?vue&type=style&index=0&id=d146e34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d146e34c",
  null
  
)

export default component.exports